import { useAuth } from "@/context/AuthContext";
import { MapPin, LogOut } from "lucide-react";

const roleLabel = { landlord: "Landlord Portal", tenant: "Tenant Portal", contractor: "Contractor Portal" };

export default function PortalLayout({ children, title, subtitle, icon: Icon }) {
  const { user, company, logout } = useAuth();
  const initials = (user?.name || "U").split(" ").map((n) => n[0]).slice(0, 2).join("");

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-slate-900 text-white">
        <div className="max-w-5xl mx-auto px-6 h-16 flex items-center">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center"><MapPin size={18} /></div>
            <div>
              <span className="font-display font-bold text-lg tracking-tight">PinPoint</span>
              <span className="text-xs text-slate-400 ml-2">{roleLabel[user?.role]}</span>
            </div>
          </div>
          <div className="ml-auto flex items-center gap-4">
            <span className="text-sm text-slate-300 hidden sm:block">{company?.name}</span>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-full bg-blue-600/30 border border-blue-500/30 text-blue-200 text-xs font-semibold flex items-center justify-center">{initials}</div>
              <span className="text-sm hidden sm:block">{user?.name}</span>
            </div>
            <button data-testid="portal-logout" onClick={logout} className="text-slate-400 hover:text-white transition-colors"><LogOut size={18} /></button>
          </div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-8">
        <div className="mb-8 fade-up flex items-center gap-4">
          {Icon && <div className="w-12 h-12 rounded-xl bg-blue-100 text-blue-700 flex items-center justify-center"><Icon size={24} /></div>}
          <div>
            {subtitle && <p className="text-xs font-medium uppercase tracking-[0.2em] text-blue-700 mb-1">{subtitle}</p>}
            <h1 className="font-display text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
          </div>
        </div>
        {children}
      </main>
    </div>
  );
}
